// Filtro do bloco Cobertura de tabela vindo do link do alerta (PO1-3659 H3):
// ?bloco=cobertura&transportadora=<idMatriz>&origem=cte|nf|spot.

export const ORIGENS_COBERTURA = { cte: "CT-e", nf: "NF", spot: "Cotação spot" };

// URLSearchParams -> { transportadora, origem } ou null (sem filtro válido).
export function coberturaDaUrl(q) {
  const transportadora = Number(q.get("transportadora"));
  const origem = q.get("origem");
  const filtro = {
    transportadora: Number.isInteger(transportadora) && transportadora > 0 ? transportadora : null,
    origem: Object.prototype.hasOwnProperty.call(ORIGENS_COBERTURA, origem) ? origem : null,
  };
  return filtro.transportadora || filtro.origem ? filtro : null;
}

// ?embarcador=<id> do link do alerta (QA PO1-3659): quem assina para todos os
// embarcadores abre o indicador já na empresa do aviso.
export function embarcadorDaUrl(q) {
  const id = Number(q.get("embarcador"));
  return Number.isInteger(id) && id > 0 ? id : null;
}

// URL sem o filtro do alerta (✕ do selo): tira transportadora e origem.
export function semFiltroCobertura(search) {
  const q = new URLSearchParams(search || "");
  q.delete("transportadora");
  q.delete("origem");
  const s = q.toString();
  return s ? `?${s}` : "";
}

// Parâmetros do filtro para a API (só os preenchidos).
export function paramsCobertura(f) {
  const p = {};
  if (f && f.transportadora) p.transportadora = f.transportadora;
  if (f && f.origem) p.origem = f.origem;
  return p;
}
